import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getUserListAll } from "@/api/user";
export var userInfo = {
  namespaced: true,
  state: {
    isInit: 0,
    userInfoKv: {}
  },
  mutations: {
    setUserInfoKv: function setUserInfoKv(state, userInfoMap) {
      state.isInit = 1;
      state.userInfoKv = userInfoMap;
    }
  },
  actions: {
    getUserInfoMap: function getUserInfoMap(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, userInfoMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return getUserListAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                userInfoMap = {};
                res.data.list.forEach(function (val) {
                  userInfoMap[val.ID] = val.nickName;
                });
                userInfoMap['0'] = '系统';
                // dictionaryMap[res.data.resysDictionary.type] = dict
                commit("setUserInfoKv", userInfoMap);
                // return state.dictionaryMap[type]
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  getters: {
    getUserInfoMap: function getUserInfoMap(state) {
      return state.userInfoKv;
    }
  }
};